/**
 * @generated SignedSource<<ac3e6ca050368e540eb921f700c21687>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppHome$data = {
  readonly appSwitcher_unitProfile?: {
    readonly __typename: "AppSwitcherUnitProfile";
    readonly unitName: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "AppHome";
};
export type AppHome$key = {
  readonly " $data"?: AppHome$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppHome">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "appSwitcherProductAri"
    },
    {
      "kind": "RootArgument",
      "name": "skipAppSwitcherUnitProfile"
    }
  ],
  "kind": "Fragment",
  "name": "AppHome",
  "selections": [
    {
      "condition": "skipAppSwitcherUnitProfile",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "productAri",
              "variableName": "appSwitcherProductAri"
            }
          ],
          "kind": "LinkedField",
          "name": "appSwitcher_unitProfile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "unitName"
                }
              ],
              "type": "AppSwitcherUnitProfile"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "e34719a622db87e1a34c693642b3d185";

export default node;
